import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";

function ScoreHeader() {
	return (
		<>
			<span>{"Score"}</span>
			<span data-tip="tooltip" data-for="scoreInfo">
				<FontAwesomeIcon
					icon={faInfo}
					className="fas fa-info-circle scoreInfo-icon mt-2"
				/>
			</span>
			<ReactTooltip
				id="scoreInfo"
				className="ScoreInfoToolTip"
				place="bottom"
				effect="solid"
				variant="light"
				positionStrategy="fixed"
			>
				{"Scores are calculated on Following criteria:\n" +
					"5- MEE : If submission date is less than or equal to weekend date\n" +
					"4- ME+: If submissiond date is one day greater than weekend date\n" +
					"3- ME: If submissiond date is two days greater than weekend date\n" +
					"2- ME-: If submissiond date is three days greater than weekend date\n" +
					"1- FME-: If submissiond date is fours or more days greater than weekend date\n"}
			</ReactTooltip>
		</>
	);
}

export default ScoreHeader;
